<template>
  <div class="w-full text-normal font-normal px-2">
    <form @submit.prevent="fetchData(q)">
      <label class="flex space-x-2 items-center my-2">
        <span>
          Showing site :
          {{ data.site?.name }}
        </span>

        <span class="mx-3 badge badge-warning">
          {{ route.params.uuid }}
        </span>
      </label>

    </form>
    <div class="bg-white rounded-md">

      <div ref="chartDowntime">

      </div>
    </div>
    <div class="grid grid-cols-2 gap-x-2 mt-2">
      <div class="card">
        <div class="card-title text-sm">
          Machines
        </div>
        <canvas ref="el" class="bg-white my-2 rounded-md">
        </canvas>
      </div>
      <div class="card">
        <div class="card-title text-sm">
          Machines
        </div>
        <canvas ref="el" class="bg-white my-2 rounded-md">
        </canvas>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-x-2 mt-2">
      <div class="card">
        <div class="card-title">
          Machines
        </div>
        <a :href="'/dashboard/machines/' + i.uuid" v-for="i in data.machines" class=" my-2 rounded-md">
          {{ i.name }}
        </a>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-x-2 mt-2">
      <div class="card">
        <div class="card-title">
          Sites
        </div>
        <a :href="'/dashboard/sites/' + i.uuid" v-for="i in data.sites" class=" my-2 rounded-md">
          {{ i.name }}
        </a>
      </div>
    </div>

  </div>
</template>
<script setup>
import {ref, onMounted} from 'vue'
import {useRoute} from "vue-router";

let route = useRoute();
let q = ref('');
const el = ref();
let uuid = route.params.uuid ;
const chartDowntime = ref();
let data = ref({sites: [], machines : [], site: null});
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
  LineController,
  LineElement,
  PointElement
} from "chart.js";

Chart.register([
  CategoryScale,
  LineController,
  LineElement,
  LinearScale,
  BarController,
  BarElement,
  PointElement
]);
let fetchData = (q) => {
  fetch(`/dashboard/sites/${uuid}?format=json`).then(r => r.json()).then(r => {
    data.value.sites = r.children;
    data.value.site = r.site;
  }).then(() => {
    const ctx = el.value;
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: '# of Votes',
          data: [12, 19, 3, 5, 2, 3],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  })
}
const downtime = () => {
  fetch(`/dashboard/machines?site_id=${route.params.uuid}&format=json&q=` + q).then(r => r.json()).then(r => {
    console.log(r);
    console.log(r);
    console.log(r);
    data.value.machines = r.machines;
    return r ;
  }).then((r) => {
    var options = {
      series: [{
        name: 'Marine Sprite',
        data: [44, 55, 41, 37, 22, 43, 21]
      }, {
        name: 'Striking Calf',
        data: [53, 32, 33, 52, 13, 43, 32]
      }, {
        name: 'Tank Picture',
        data: [12, 17, 11, 9, 15, 11, 20]
      }, {
        name: 'Bucket Slope',
        data: [9, 7, 5, 8, 6, 9, 4]
      }, {
        name: 'Reborn Kid',
        data: [25, 12, 19, 32, 25, 24, 10]
      }],
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        stackType: '100%'
      },
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      title: {
        text: '100% Stacked Bar'
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "K"
          }
        }
      },
      fill: {
        opacity: 1

      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    };
    var chart = new ApexCharts(chartDowntime.value, options);
    chart.render();
  })
};
onMounted(() => {
  fetchData('');
  downtime();

})
</script>